var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.content)?_c('column-node',_vm._g({attrs:{"content":_vm.content}},_vm.$listeners)):_vm._t("default"),_c('v-text-field',{staticClass:"d-none",attrs:{"value":_vm.parameterAnswered,"disabled":"","rules":[_vm.$validation.required()]}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }